<template>
  <div>
    <div v-if="(!data || data.length === 0) && loading">
      <SingleChartLoader></SingleChartLoader>
    </div>
    <div v-if="(!data || data.length === 0) && !loading" class="text-center py-5">
      <h4>Chart data is not available.</h4>
    </div>
    <div v-else-if="data && data.length > 0 && yDataAvailable === true && !loading"
      class="chart-column liberated-gas-chart-column">
      <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
      <ChartTitleTooltip :title="chartTitle" />
      <div v-if="isMounted" class="main-chart">
        <div :ref="chartId"></div>
      </div>
      <v-dialog v-model="modal" class="multi-chart-preview-div dashboard-chart-preview composition liberated-gas-chart-preview">
        <v-card class="position-relative studio-card">
          <v-card-text>
            <div class="popup-top">
              <div class="modal-tab-div">
            <div class="tab-div">
                <p>Y Axis Scale:</p>
                <v-btn-toggle
                    v-model="isModalYLog"
                    class="axis-toggle setHeight"
                    mandatory
                    @update:modelValue="handleModalYScaleToggleChange"
                  >
                  <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                    <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                  </v-btn-toggle>
            </div>
          </div>
              <ChartTitleTooltip :title="chartTitle" extra-class="w-100" />
              <!-- <img :src="cross" alt="cross" @click="closeModal" class="chart-preview-close-btn"> -->
            </div>
            <div :ref="modalChartId" class="modal-chart-container"></div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <div v-else-if="data && data.length > 0 && yDataAvailable === false" class="text-center pt-5 pb-12">
      <h4>Chart data is not available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import SingleChartLoader from "../../Loaders/SingleChartLoader.vue";
import Expand from "../../../../assets/Svg/Chart/expand-btn.svg";
import downloadIcon from '../../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../../assets/Svg/camIcon.svg';
import { mapGetters } from "vuex";
import { chartGridColor, mergePlotlyTheme, applyPlotlyGridLineStroke, applyPlotlyPlotBackground, getPlotlyBackgroundRelayout } from "@/utils/chartTheme";
import { downloadPlotlyHostAsPng } from "@/utils/plotlyPngDownload";
import ChartTitleTooltip from "./ChartTitleTooltip.vue";
import { buildFractionYAxisConfig } from "@/utils/plotlyLogAxis";
import { stripRedundantPercentFromLabel } from "@/utils/chartAxisUtils";

export default {
  name: "GasCompPressureChart",
  components: {
    SingleChartLoader,
    ChartTitleTooltip,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    toggleFraction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      cross: require("../../../../assets/Svg/Chart/chart-cross.svg"),
      chartId: "lineChart",
      chartData: [],
      uniqueFluidComponents: [],
      modal: false,
      modalChartId: "modalLineChart",
      chartTitle: "Vapor Compositions Across Pressures for Each Component",
      isMounted: false,
      yDataAvailable: true,
      yAxisScale: "linear",
    isYLog: false,
    modalYAxisScale: "linear",
    isModalYLog: false,
    };
  },
  computed: {
    ...mapGetters("darkMode", ["isDarkMode"]),
  },
  watch: {
    data(newVal, oldVal) {
      if (newVal !== oldVal && newVal.length > 0) {
        this.plotChart();
      }
    },
    yAxisScale() {
      this.plotChart();
    },
    isDarkMode() {
      this.plotChart();
    }
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    handleYScaleToggleChange() {
    if (this.yAxisScale === undefined) {
      this.yAxisScale = 'linear';
    }

      this.yAxisScale = this.isYLog ? "log" : "linear";
      this.modalYAxisScale = this.yAxisScale;
    if(this.modalYAxisScale === "log") {
      this.isModalYLog = true;
    }
    else {
this.isModalYLog = false;
    }
  },
  handleModalYScaleToggleChange() {
    if (this.modalYAxisScale === undefined) {
      this.modalYAxisScale = 'linear';
    }

      this.modalYAxisScale = this.isModalYLog ? "log" : "linear";

      this.plotModalChart()
  },
    plotChart() {
      const differentiaLiberationData = this.data;
      const vaporMoleFractionsByComponent = {};
      const vaporMassFractionsByComponent = {};

      differentiaLiberationData.forEach((step) => {
        const fluidComponent = step.fluidComponentReference;
        const vaporMoleFraction = step.vapor_MoleFraction;
        const vaporMassFraction = step.vapor_MassFraction;
        const stepPressure = step.stepPressure;
        if (!vaporMoleFractionsByComponent[fluidComponent]) {
          vaporMoleFractionsByComponent[fluidComponent] = [];
        }
        vaporMoleFractionsByComponent[fluidComponent].push({ pressure: stepPressure, moleFraction: vaporMoleFraction });
        if (!vaporMassFractionsByComponent[stepPressure]) {
          vaporMassFractionsByComponent[stepPressure] = [];
        }

        vaporMassFractionsByComponent[stepPressure].push({ pressure: stepPressure, massFraction: vaporMassFraction });
      });

      if (this.toggleFraction === true) {
        this.chartData = Object.entries(vaporMoleFractionsByComponent).map(([component, values]) => {
          const xData = values.map(entry => entry.pressure);
          const yData = values.map(entry => entry.moleFraction);

          if (yData.every(value => value === undefined) || yData.every(value => value === null) || !yData) {
            this.yDataAvailable = false;
          }
          else {
            this.yDataAvailable = true;
          }

          return {
            name: component,
            x: xData,
            y: yData,
          };
        });
      } else if (this.toggleFraction === false) {
        this.chartData = Object.entries(vaporMassFractionsByComponent).map(([component, values]) => {
          const xData = values.map(entry => entry.pressure);
          const yData = values.map(entry => entry.massFraction);

          if (yData.every(value => value === undefined) || yData.every(value => value === null) || !yData) {
            this.yDataAvailable = false;
          }
          else {
            this.yDataAvailable = true;
          }

          return {
            name: component,
            x: xData,
            y: yData,
          };
        });
      }

      this.$nextTick(() => {
        if (this.isMounted && this.$refs[this.chartId]) {
          this.plotChartWithData();
        }
      });
    },

    plotChartWithData() {
      const chartEl = this.$refs[this.chartId];
      if (!chartEl) return;

      Plotly.newPlot(
        chartEl,
        this.buildTraces(this.yAxisScale || "linear"),
        this.buildChartLayout(this.yAxisScale || "linear"),
        this.buildPlotConfig()
      ).then(() => {
        this.finalizePlot(chartEl);
      });
    },

    finalizePlot(chartEl) {
      if (!chartEl) return;

      Plotly.relayout(chartEl, getPlotlyBackgroundRelayout(this.isDarkMode)).finally(() => {
        applyPlotlyPlotBackground(chartEl, this.isDarkMode);
        applyPlotlyGridLineStroke(chartEl, this.isDarkMode);
      });
    },

    buildTraces(scale = "linear") {
      const useLog = scale === "log";
      return this.chartData.map((series) => ({
        x: series.x,
        y: useLog
          ? series.y.map((value) => {
              const n = typeof value === "number" ? value : parseFloat(value);
              return Number.isFinite(n) && n > 0 ? n : null;
            })
          : series.y,
        type: "scatter",
        mode: "lines+markers",
        name: series.name,
        hovertemplate: `%{y:.3f}<extra></extra>`,
      }));
    },

    buildChartLayout(scale, isModal = false) {
      const yAxisTitle = this.toggleFraction ? "Mole" : "Mass";

      return mergePlotlyTheme(
        {
          xaxis: {
            title: {
              text: "Pressure (psia)",
              standoff: 10,
            },
            automargin: true,
            gridcolor: chartGridColor(this.isDarkMode),
          },
          yaxis: buildFractionYAxisConfig(scale, this.chartData, {
            title: yAxisTitle,
            gridcolor: chartGridColor(this.isDarkMode),
            simpleLog: true,
          }),
          margin: {
            l: 50,
            r: isModal ? 120 : 80,
            b: 120,
          },
          showlegend: true,
          legend: { x: 1.02, y: 1, orientation: "v" },
        },
        this.isDarkMode
      );
    },

    buildPlotConfig() {
      return {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
        modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Expand",
            icon: {
              svg: `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <image href="${Expand}" width="24" height="24"/>
                  </svg>
                `,
            },
            click: this.openModal,
          },
          {
            name: "Download CSV",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV,
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG,
          },
        ],
      };
    },

    plotModalChart() {
      const chartEl = this.$refs[this.modalChartId];
      if (!chartEl) return;

      Plotly.Plots.resize(chartEl);
      Plotly.newPlot(
        chartEl,
        this.buildTraces(this.modalYAxisScale || "linear"),
        this.buildChartLayout(this.modalYAxisScale || "linear", true),
        this.buildPlotConfig()
      ).then(() => {
        this.finalizePlot(chartEl);
      });
    },


    openModal() {
      this.modal = true;
      this.$nextTick(() => {
        this.plotModalChart();
      });
    },

    closeModal() {
      this.modal = false;
    },

    handleDownloadCSV() {
      this.downloadChartCSV();
    },

    handleDownloadPNG() {
      this.downloadChartPNG();
    },

    downloadChartPNG() {
      const chartElement = this.$refs[this.chartId];
      if (!chartElement) return;
      downloadPlotlyHostAsPng(chartElement, this.chartTitle || "chart", {
        isDarkMode: this.isDarkMode,
      });
    },

    downloadChartCSV() {
      const valueColumnHeader = stripRedundantPercentFromLabel(
        this.toggleFraction ? "Vapor Component Mole" : "Vapor Component Mass"
      );
      const csvHeader = [`Pressure (psia),${valueColumnHeader}\n`];

      const csvRows = this.chartData.map((series) =>
        series.x.map((x, index) => `${x},${series.y[index]}`).join("\n")
      );

      const csvContent = csvHeader + csvRows.join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "chart-data.csv";

      a.click();

      URL.revokeObjectURL(url);
    }
  },
};
</script>